var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojilarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57 16.34v0a6.59 6.59 0 0 0 10.65.1l.08-.1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24 9.04c0-.88-.6-1.6-1.34-1.6-.73 0-1.33.72-1.33 1.6 0 .88.6 1.6 1.33 1.6.74 0 1.34-.72 1.34-1.6ZM15.96 7.44c-.73 0-1.33.72-1.33 1.6 0 .88.6 1.6 1.33 1.6.74 0 1.34-.72 1.34-1.6 0-.88-.6-1.6-1.34-1.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojilarge);
export default __webpack_public_path__ + "static/media/emoji.large.cecd88f08371bdbc6f449d453ad15fa8.svg";
export { ForwardRef as ReactComponent };